<template>
  <div>
    <el-drawer title="选择审批人" :visible.sync="drawer" direction="rtl" size="67%">
      <!-- 发起步骤 -->
      <div class="steps">
        <step-item title="发起人">
          <avatar-person :isCheck="isCheck" isOriginator :personList="originator" />
        </step-item>
        <step-item v-loading="approverLoading" title="审批人">
          <avatar-person
            :isCheck="isCheck"
            type="审批"
            :personList="approver"
            multiple
            @add-person="addPerson"
            @delete-person="deletePerson"
          />
          <div v-if="isQY" class="flex mt-3">
            <avatar-person
              :isCheck="true"
              type="审批"
              :personList="finalAuditors"
              multiple
            />
          </div>
        </step-item>
        <step-item isRequired :title="'支付人' + (isInvestigator ? '' : '（该支付人采取线下对公打款，打款后需线上确认）')">
          <avatar-person
            :isCheck="isCheck"
            type="支付"
            :personList="payer"
            @add-person="addPerson"
            @delete-person="deletePerson"
          />
        </step-item>
        <step-item isFinished title="备注">
          <el-input
            class="w-full"
            style="height: 128px"
            type="textarea"
            :maxlength="200"
            :disabled="isCheck"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入"
            resize="none"
            v-model="message"
          >
          </el-input>
        </step-item>
      </div>
      <!-- 底部按钮 -->
      <footer
        class="box-border px-6 bg-white text-right -ml-6 fixed bottom-0 z-10"
        style="height: 64px; line-height: 64px; border-top: 1px solid rgba(0, 0, 0, 0.1); width: 67%"
      >
        <el-button v-if="!isCheck" type="primary" plain @click="drawer = false" class="mr-0.5">暂不发起</el-button>
        <!-- 发起审批按钮 -->
        <el-popover title="确认提交费用审批" v-model="approvalVisible" placement="top-end" width="350" trigger="click">
          <p class="my-6">发起审批后所有审批人员将依次收到审批任务</p>
          <div class="text-right">
            <el-button class="normal-button" @click="approvalVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmApproval">确认发起审批</el-button>
          </div>
          <el-button slot="reference" :disabled="!this.payer.length" v-show="!isCheck" type="primary" class="ml-2"
            >发起审批</el-button
          >
        </el-popover>
        <!-- 撤销审批按钮 -->
        <el-popover title="确认撤销费用审批" v-model="cancelApprovalVisible" placement="top-end" width="350" trigger="click">
          <p class="my-6">撤消后审批人接收不到此次审批结算项目，您可再次发起审批</p>
          <div class="text-right">
            <el-button class="normal-button" @click="cancelApprovalVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmCancel">确认撤销审批</el-button>
          </div>
          <el-button slot="reference" v-show="isCheck && this.auditStatus !== AUDIT_STATUS.PAYING" type="primary">撤销审批</el-button>
        </el-popover>
         <!-- 撤销审批按钮(支付中) -->
         <el-button slot="reference" @click="cancelPaying" v-show="isCheck && this.auditStatus === AUDIT_STATUS.PAYING" type="primary">撤销审批</el-button>
      </footer>
    </el-drawer>
    <el-dialog
      :custom-class="title === '审批' ? 'audit-show' : ''"
      :title="'选择' + title + '人'"
      :visible.sync="visible"
      :width="title === '审批' ? '766px' : '48%'"
    >
      <div v-if="title === '审批'" class="flex overflow-auto h-96">
        <!-- 左半部分 -->
        <div class="select-user flex flex-1 flex-col px-6 overflow-auto box-border">
          <p class="text-medium-x font-semibold leading-22 text-theme-black-850 mb-4">已选用户</p>
          <article class="text-medium font-normal leading-24 bg-card-bg-gray px-4 py-3">
            <p class="text-theme-black-650">请从右侧选择审批人</p>
          </article>
          <ul class="overflow-y-auto pt-6">
            <li class="flex justify-between leading-22 h-9" v-for="(item, index) in disableList" :key="item.id">
              <span class="text-theme-black-650"
                >{{ item.name }}
                <span v-if="item.mobile && item.staffType !== 2" class="text-theme-black-650">({{ item.mobile }})</span></span
              >
              <span v-if="!item.disabledDel" class="text-theme cursor-pointer" @click="onClickDelUser(index)">删除</span>
            </li>
          </ul>
        </div>
        <article class="w-px h-96">
          <p style="backgroundcolor: #e7e9eb; height: calc(100% - 6px)"></p>
        </article>
        <!-- 右半部分 -->
        <dygc-user
          class="flex-1"
          is-order
          :isSingle="isSingle"
          :multiple="multiple"
          :value="disableList"
          @input="getInputList"
          ref="dygcUser"
        />
      </div>

      <el-select v-else v-model="payerV" filterable placeholder="请选择">
        <el-option v-for="item in payerList" :key="item.id" :label="item.name + '-' + item.mobile" :value="item.id"> </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button class="normal-button" @click="cancel">取 消</el-button>
        <el-button class="normal-button" type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog :title="isCheck ? '确认撤销费用审批' : '确认提交费用审批'" :visible.sync="approvalVisible" width="45%">
      <p>
        <span v-if="isCheck">撤消后审批人接收不到此次审批结算项目，您可再次发起审批</span>
        <span v-else>发起审批后所有审批人员将依次收到审批任务</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button class="normal-button" @click="approvalVisible = false">{{ isCheck ? '暂不撤销' : '暂不发起' }}</el-button>
        <el-button v-if="isCheck" class="normal-button" type="primary" @click="confirmCancel">确认撤销</el-button>
        <el-button v-else class="normal-button" type="primary" @click="confirmApproval">发起审批</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import StepItem from './StepItem'
import AvatarPerson from './AvatarPerson'
import DygcUser from '@/components/dygc-user/DygcUser'
import { getStaffForPay } from '@/api/wenjuan/settlement'
import { startAudit, cancelAudit, finalAuditors } from '@/api/cost-settlement/settlement-initiate/submitStatement'
import { getApprovalDetailProcess } from '@/api/cost-settlement/myRelate'
import { statisticsDetail } from '@/api/cost-settlement/common'
import { AUDIT_STATUS, SETTLE_OBJ_TYPE } from '../settleConst'
import GlobalConfig from '@/global/config'
import { mapGetters } from 'vuex'

let saveData = {}
export default {
  components: { StepItem, AvatarPerson, DygcUser },
  data() {
    return {
      AUDIT_STATUS,
      drawer: false,
      message: '',
      title: '',
      visible: false,
      disableList: [],
      isSingle: false,
      multiple: false,
      approver: [],
      payer: [],
      finalAuditors: [],
      originator: [],
      companyId: GlobalConfig.getCompanyId(),
      payerList: [],
      payerV: '',
      // approverSave: [],
      payerSave: [],
      isCheck: false,
      approvalVisible: false,
      cancelApprovalVisible: false,
      auditStatus: null,
      approverLoading: false
    }
  },
  props: {
    // originator: {
    //   type: Array,
    //   default: () => []
    // }
    sid: {
      type: [String, null],
      default: null
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    statementId() {
      return this.sid ?? this.$route.query.statementId
    },
    customerUserInfo() {
      return this.$store.getters.customerUserInfo
    },
    settleObjType() {
      return this.$route.query.settleObjType ?? SETTLE_OBJ_TYPE.INVESTIGATOR
    },
    isInvestigator() {
      return this.settleObjType == SETTLE_OBJ_TYPE.INVESTIGATOR
    },
    approverSave() {
      return (this.disableList??[]).map(item => ({ ...item, phone: item.mobile, deptName: (item.organs??[]).map(o => o.name).join(',') }))
    },
    isQY() {
      return this.userInfo.isQY
    }
  },
  mounted() {
    const { id, name, username, phone, photo } = this.customerUserInfo
    this.originator = [{ id, name: name ?? username, phone, photo }]
    this.getStaffForPay()
    this.statisticsDetail()
    // ;(this.isCheck || this.auditStatus === AUDIT_STATUS.REJECT) && this.getProcess()
  },
  methods: {
    getProcess() {
      getApprovalDetailProcess(this.statementId).then(res => {
        if (res.data.code != 0) return
        const { data=[] } = res.data
        //发起人返显示
        var { assigneeName: name, assigneePhone: phone, assigneePhoto: photo, comment } = data[0]
        this.originator = [{ name, phone, photo }]
        //备注信息返显
        this.message = comment
        //付款人返显
        var {
          allowModifyAnswers,
          assigneeCompanyId: companyId,
          assigneeBaseId: customerId,
          assigneeStaffId: id,
          mobile,
          assigneeName: name,
          status,
          weixinNickName,
          assigneePhoto: photo,
          assigneeDept: deptName,
          assigneePhone: phone
        } = data[data.length - 1]
        this.payer = [
          {
            allowModifyAnswers,
            companyId,
            customerId,
            id,
            mobile,
            name,
            status,
            weixinNickName,
            photo,
            deptName,
            phone
          }
        ]
        //审批人反显
        const approver = data.slice(1, data.length - 1).map(item => {
          const {
            allowModifyAnswers,
            assigneeCompanyId: companyId,
            assigneeBaseId: customerId,
            assigneeStaffId: id,
            mobile,
            assigneeName: name,
            status,
            weixinNickName,
            assigneePhoto: photo,
            assigneeDept: deptName,
            assigneePhone: phone
          } = item
          return {
            allowModifyAnswers,
            companyId,
            customerId,
            id,
            mobile,
            name,
            status,
            weixinNickName,
            photo,
            deptName,
            phone
          }
        })
        if(this.isQY) {
          this.getfinalAuditors(1, approver)
        }else {
          this.approver = approver
        }
      })
    },
    getfinalAuditors(type, approver) {
      this.approverLoading = true
      //固定审批人返显 "types": [ //类型：0费用结算 1红包 2短信 不传改参数时查全部]
      finalAuditors({types: [0]}).then(res=> {
        if(!res.data?.data) return
        const list = res.data.data.reverse()
        
        let finalAuditors = list[0].auditorList.map(person => ({
          ...person,
          companyId: +person.companyId,
          disabledDel: true
        }))
        if(list[0].status === 0) {
          finalAuditors = []
        }
        if(type === 1) { //回显
          if(this.auditStatus === AUDIT_STATUS.REJECT) {
            this.finalAuditors = finalAuditors
          }else {
            const aIds = approver.map(item => item.id)
            this.finalAuditors = finalAuditors.filter(item => aIds.includes(item.id))
          }
          const ids = this.finalAuditors.map(item => item.id)
          console.log('ids', ids)
          this.approver = approver.filter(item => !ids.includes(item.id))
        }else {
          this.finalAuditors = finalAuditors
        }
      }).finally(()=>{
        this.approverLoading = false
      })
    },
    statisticsDetail() {
      statisticsDetail(this.statementId).then(res => {
        if (res.data.code !== 0) {
          return
        }
        this.auditStatus = res.data.data.auditStatus
        if (
          this.auditStatus >= AUDIT_STATUS.AUDITING &&
          this.auditStatus <= AUDIT_STATUS.PAYING &&
          this.auditStatus !== AUDIT_STATUS.REJECT
        ) {
          this.isCheck = true
        } else if (
          this.auditStatus === AUDIT_STATUS.READY ||
          this.auditStatus === AUDIT_STATUS.CANCEL ||
          this.auditStatus === AUDIT_STATUS.REJECT
        ) {
          this.isCheck = false
        }
        if(this.isCheck || this.auditStatus === AUDIT_STATUS.REJECT) {
          this.getProcess()
        }else if (JSON.stringify(saveData) !== '{}'){
          this.originator = saveData.originator
          this.approver = saveData.approver
          this.payer = saveData.payer
          this.message = saveData.message
          if(this.isQY) {
            this.getfinalAuditors()
          }
        }else {
          if(this.isQY) {
            this.getfinalAuditors()
          }
        }
      })
    },
    //确认撤销
    confirmCancel() {
      cancelAudit(this.statementId)
        .then(res => {
          if (res.data.code !== 0) {
            this.$message.warning(res.data.msg)
            return
          }
          this.$message.success(res.data.data)
          this.drawer = false
          this.cancelApprovalVisible = false
          setTimeout(() => {
            this.isCheck = false
          }, 500)
          this.payer = []
          this.approver = []
          this.message = ''
        })
        .catch(err => {})
        .finally(() => {
          this.$emit('finished-approval')
        })
    },
    //确认发起
    confirmApproval() {
      let approvers = this.approver??[]
      if(this.isQY) {
        approvers = [...this.approver, ...this.finalAuditors]
      }
      const query = {
        auditors: (approvers).map(item => ({
          allowModifyAnswers: item.allowModifyAnswers ?? '',
          companyId: item.companyId ?? '',
          customerId: item.customerId ?? '',
          id: item.id ?? '',
          mobile: item.mobile ?? '',
          name: item.name ?? '',
          status: item.status ?? '',
          weixinNickName: item.weixinNickName ?? '',
          photo: item.photo ?? '',
          deptName: item.deptName ?? ''
        })),
        payer: (this.payer??[]).map(item => ({
          allowModifyAnswers: item.allowModifyAnswers ?? '',
          companyId: item.companyId ?? '',
          customerId: item.customerId ?? '',
          id: item.id ?? '',
          mobile: item.mobile ?? '',
          name: item.name ?? '',
          status: item.status ?? '',
          weixinNickName: item.weixinNickName ?? '',
          photo: item.photo ?? '',
          deptName: item.deptName ?? ''
        }))[0],
        remark: this.message,
        statementId: this.statementId
      }
      query.auditors.forEach(item => {
        if (!item.photo) {
          delete item.photo
        }
        if (!item.deptName) {
          delete item.deptName
        }
      })
      !query.payer.deptName && delete query.payer.deptName
      !query.payer.photo && delete query.payer.photo
      startAudit(query)
        .then(res => {
          if (res.data.code !== 0) {
            this.$message.warning(res.data.msg)
            return
          }
          this.approvalVisible = false
          this.$message.success(res.data.data)
          this.drawer = false
          setTimeout(() => {
            this.isCheck = true
          }, 500)
        })
        .catch(err => {})
        .finally(() => {
          this.$emit('finished-approval')
        })
    },
    //发起审批
    // toApproval() {
    //   if (!this.payer.length) {
    //     this.$message.warning('请选择支付人')
    //     return
    //   }
    //   // if (!this.message.length) {
    //   //   this.$message.warning('请填写备注')
    //   //   return
    //   // }
    //   this.approvalVisible = true
    // },
    //撤销审批
    // cancelApproval() {
    //   this.approvalVisible = true
    // },
    getInputList(value) {
      if(this.isQY) {
        const ids = this.finalAuditors.map(item => item.id)
        this.disableList = value.filter(item => !ids.includes(item.id)).concat(this.finalAuditors)
      }else {
        this.disableList = value
      }
      // this.approverSave = value.map(item => ({ ...item, phone: item.mobile, deptName: item.organs.map(o=>o.name).join(',')}))
    },
    cancel() {
      this.visible = false
      this.approver = JSON.parse(JSON.stringify(this.approver))
    },
    confirm() {
      if (this.title === '审批') {
        if(this.isQY) {
          const ids = this.finalAuditors.map(item => item.id)
          this.approver = this.approverSave.filter(item => !ids.includes(item.id))
        }else {
          this.approver = this.approverSave
        }
      } else {
        //支付
        const one = this.payerList.find(item => item.id === this.payerV)
        this.payer = [{ ...one, phone: one.mobile, deptName: (one.organs??[]).map(o => o.name).join(',') }]
      }
      this.visible = false
    },
    addPerson(type) {
      this.title = type
      this.visible = true
      if(this.isQY) {
        this.disableList = [...this.approver, ...this.finalAuditors]
      }else {
        this.disableList = this.approver
      }
      this.payerV = (this.payer??[]).map(item => item.id)
    },
    deletePerson({ id, type }) {
      if (type === '审批') {
        const index = this.approver.findIndex(item => item.id === id)
        this.approver.splice(index, 1)
      } else {
        //支付
        this.payer = []
      }
    },
    getStaffForPay() {
      getStaffForPay({ companyId: this.companyId }).then(res => {
        if (res.data.code != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.payerList = res.data.data
        //清研灵智、先进数治、数馨信息、清研河南、清研环境
        // if(['7', '1451339', '1451335', '1451362', '1451338'].includes(this.companyId)) {
        //   const idx =  (res?.data?.data??[]).findIndex(p => p.id == '101478') //谢丽红
        //   if(idx > -1 ) {
        //     this.payerList = (res?.data?.data??[]).filter(p => p.id == '101478')//谢丽红
        //   }else {
        //     this.payerList = []
        //   }
        // }
        
      })
    },
    open() {
      this.drawer = true
      this.statisticsDetail()
      // ;(this.isCheck || this.auditStatus === AUDIT_STATUS.REJECT) && this.getProcess()
    },
    //选择审批人左侧的删除
    onClickDelUser(index) {
      this.disableList.splice(index, 1)
    },
    //支付中的撤销
    cancelPaying() {
      this.$confirm('待支付的费用结算，不能直接撤销，可联系支付人驳回', '提示', {
        confirmButtonText: '我知道了',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
      })
    }
  },
  watch: {
    drawer(n) {
      if (!n) {
        const { originator, approver, payer, message } = this
        saveData = { originator, approver, payer, message }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__header {
  background-color: #f5f7fa;
}
::v-deep .el-drawer__body {
  @apply p-6;
}

.steps {
  @apply w-full;
  ::v-deep .el-textarea__inner {
    height: 100% !important;
  }
}

::v-deep .el-step__icon {
  width: 9px;
  height: 9px;
  align-items: start;
}
::v-deep .el-step__icon .is-text {
  border: 1px solid;
  @apply bg-theme border-theme;
}
::v-deep .el-step .el-step__head {
  width: 16px !important;
}
::v-deep .el-step .el-step__line {
  width: 1px;
  left: 4px;
  top: 9px;
  bottom: -9px;
  @apply bg-theme;
}
::v-deep .el-step__line {
}

::v-deep .audit-show {
  .el-dialog__body {
    @apply p-0;
  }
  .el-dialog__footer {
    @apply pr-6 py-4 border-t border-black border-opacity-10 border-solid;
  }
  .add-audit-content {
    & div {
      @apply flex-1;
    }
  }
}
</style>
